










































































































































































































































import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
import { UserProfile } from '../../models/userdata/profile';
import { UserSkillsWrapper } from '../../models/skills/userskillwrapper';
import Datepicker from 'vuejs-datepicker';
import { UserSkill } from '../../models/skills/skills';
import { SkillType } from '../../models/userdata/skilltype';
import { CompanySkill } from '../../models/skills/companyskills';
import Paginate from 'vuejs-paginate';
import { SkillResponse } from '../../models/skills/skillresponse';
import { VerticalSkillRespose } from '../../models/skills/VerticalSkillRespose';
import { BFormFile } from 'bootstrap-vue/es/components';
import { UserAttribute } from '../../models/skills/userattribute';
import { SkillDocWrapper } from '../../models/skills/skilldocwrapper';
import { DocumentPayload } from '../../models/skills/documentpayload';
import { UserAttrSkillWrapper } from '../../models/skills/userattrskillwrapper';
import { SkillDocument } from '../../models/skills/skilldocument';
Vue.component('paginate', Paginate);
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { DocumentResponse } from '../../models/skills/documentresponse';
import { SpinnerPlugin } from 'bootstrap-vue/es/components';
import Loader from '../Loader.vue';
import GuidedSignupUtilities from '@/components/GuidedSignup/utilities';
import SkillCard from '@/components/Commons/SkillCard.vue';
import moment from 'moment';
import { LicenceMasterDataList } from '@/models/licence/LicenceMasterDataList';
import { LicenceMasterData } from '@/models/licence/LicenceMasterData';
import { LicenceResponse } from '@/models/licence/LicenceResponse';
import { UserLicenceList } from '@/models/licence/UserLicenceList';
import { LicenceSave } from '@/models/licence/LicenseSave';
import { UserLicence } from '@/models/userlicence/UserLicence';
import { LicenceDocument } from '@/models/licence/LicenceDocument';
import { LicenceUploadPayload } from '@/models/licence/LicenceUploadPayload';
import { LicenceUploadInfo } from '@/models/licence/LicenceUploadInfo';
import ConfirmationModal from '@/components/Commons/ConfirmationModal.vue';
import SelectedLicenceList from '@/components/Commons/SelectedLicenceList.vue';
import ProfilePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'LicenceDetails',
  components: {
    Datepicker,
    Loader,
    SkillCard,
    SelectedLicenceList,
    ProfilePlaceholder,
  },
})
export default class LicenceDetails extends Mixins(GuidedSignupUtilities) {
  $refs: any;
  $moment: any;
  private userProfile: UserProfile = new UserProfile();
  private companyLicenceWrapper: LicenceMasterDataList = new LicenceMasterDataList();
  private documentPayload: DocumentPayload = new DocumentPayload();
  private saveLicencePayload: LicenceUploadPayload = new LicenceUploadPayload();
  private licenceUploadInfo: LicenceUploadInfo = new LicenceUploadInfo();
  private licenceDocument: LicenceDocument = new LicenceDocument();
  private componentKey: number = 0;
  private currentPage: number = 1;
  private recsPerPage: number = 5;
  private currentPageTop: number = 1;
  private recsPerPageTop: number = 5;
  private selectedIndex: number = -1;
  private selectedSkillId: number = -1;
  private bFormFiles: any[] = [];
  public tempSkillTypes: SkillDocWrapper[] = [];
  $wlToastr: any;
  private editLicence: boolean = false;
  private expandAll: boolean = false;
  private searchSkill: string = '';
  private filteredCompanySkills: SkillResponse[] = [];
  private companyVerticalSkills: VerticalSkillRespose[] = [];
  private filteredCompanyVerticalLicence: LicenceMasterData[] = [];
  private expandCurrent: boolean = false;
  private displayVerticalArr: String[] = [];
  private selectedUploadSkillAttr: string = '';
  private skillDocumentUploaded: string = '';
  private userAttrSkillWrappers: UserAttrSkillWrapper[] = [];
  private selectedSkills: number[] = [];
  public userFileAttributeDoc: any;
  private startDate: any;
  private skillDocument: SkillDocument = new SkillDocument();
  private skillSearchUploadDocument: SkillDocument = new SkillDocument();
  private replaceSelectedAttributeId: number = -1;
  private selectedSkill: SkillResponse = new SkillResponse();
  private selectedUserAttribute: UserAttribute = new UserAttribute();
  private selectedUserAttrSkillWrapper: UserAttrSkillWrapper = new UserAttrSkillWrapper();
  private selectedUserAttrLicenceWrapper: UserLicence = new UserLicence();
  private documentExpires: boolean = false;
  private skipSkillAttribute: String = '';
  private skipLicenceAttributes: String[] = [];
  private documentExpiresEdit: boolean = true;
  private replaceUploadedDocument: boolean = false;
  private replaceUploadedDocumentEdit: boolean = false;
  private selectedComponentKey: number = 0;
  private masterLicenceListComponentKey: number = 0;
  private effectiveDateStr: string = '';
  private showModal: boolean = false;
  private showModalEdit: boolean = false;
  private showModalXS: boolean = false;
  private uploadDocument: boolean = false;
  private selectedDocument: DocumentResponse = new DocumentResponse();
  private editMode: boolean = false;
  private editDeleteHeader: string = '';
  private editDeleteBody: string = '';
  private licenceOn: string = '';
  private licenceAuthority: string = '';
  private licenceCountry: string = '';
  private effectiveDate: string = '';
  private expiryDate: string = '';
  private supportingSkillDocTypes: String[] = [];
  private displayDocTypes: String = '';
  private supportedFileSize = 0;
  private isDropBoxFileUploaded: boolean = false;
  private dropBoxFile?: string;
  private dropBoxFileName?: string;
  @Prop({ default: () => new Vue(), type: Vue }) bus;

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get isGuidedSignupPage() {
    var str = this.$route.path!;
    console.log('str is ', str);
    console.log('returning ', str.includes('guidedsignup'));
    return str.includes('guidedsignup');
  }

  isVerticalExists(verticalName: String): boolean {
    return this.displayVerticalArr.includes(verticalName.toLowerCase());
  }

  addVertical(verticalName: String) {
    this.displayVerticalArr.push(verticalName.toLowerCase());
  }

  removeVertical(verticalName: String) {
    const filteredVerticals = this.displayVerticalArr.filter((doc) => {
      return doc.toLowerCase() != verticalName.toLowerCase();
    });
    this.displayVerticalArr = filteredVerticals;
  }

  clearDisplayVerticalArr() {
    this.displayVerticalArr = [];
  }

  addAllVerticals() {
    this.displayVerticalArr = [];
    vxm.licence.LicenseMasterDataWrapper.licenceMasterData.forEach((value) => {
      this.displayVerticalArr.push(value.verticalName.toLowerCase());
    });
  }

  get userLicence(): UserLicence[] {
    if (this.userLicenceList === null) {
      return [];
    }
    return this.userLicenceList;
  }

  async activateLicence(licence: LicenceResponse) {
    const licenceSave = new LicenceSave();
    licenceSave.licenceMasterId = licence.licenceMasterId;
    licenceSave.licenceName = licence.licenceName;
    const vm = this;
    const respPromise: any = vxm.licence.addLicenceToUserProfile(licenceSave);
    const resp = await respPromise;
    if (resp.meta.success) {
      vm.$wlToastr('success', vm.$t('licence-selected-success'), vm.$t('License_LicenceText'));
      await vxm.licence.getUserLicenceData();
      this.componentKey++;
      this.selectedComponentKey++;
    } else {
      vm.$wlToastr('error', vm.$t('licence-activation-failed'), vm.$t('License_LicenceText'));
    }
  }

  get userLicenceList() {
    return vxm.licence.UserLicenceList;
  }

  licenceExist(licence: LicenceResponse): boolean {
    return false;
    var licenceExist = false;
    var arrayLength = this.userLicence.length;
    if (this.userLicence) {
      for (var i = 0; i < arrayLength; i++) {
        if (this.userLicence[i].licenceMasterId === licence.licenceMasterId) {
          licenceExist = true;
          break;
        }
      }
    }
    return licenceExist;
  }

  async mounted() {
    this.bus.$on('on-next-step', this.onNextStep);
    await vxm.licence.getCompanyLicenceData();
    await vxm.licence.getUserLicenceData();
    await vxm.passport.fetchCountryList();
    this.userProfile = vxm.users.myUserProfile;
    this.companyLicenceWrapper = vxm.licence.LicenseMasterDataWrapper;
    this.filteredCompanySkills = vxm.skills.CompanySkillWrapper.skillResponses;
    this.companyVerticalSkills =
      vxm.skills.CompanySkillWrapper.verticalSkillResposes;
    this.filteredCompanyVerticalLicence =
      vxm.licence.LicenseMasterDataWrapper.licenceMasterData;
    this.userAttrSkillWrappers = this.userProfile.userAttributeSkills;
    this.supportedFileSize = vxm.utility.fileUploadMaxSize;
    console.log('user attribute skills:' + this.userAttrSkillWrappers.length);
  }

  onNextStep() {
    this.$emit('go-to-next');
  }

  beforeDestroy() {
    this.bus.$off('on-next-step');
  }

  saveUserProfile() {
    vxm.users.saveUserProfile({
      userProfile: this.userProfile,
      isPartofRegistration: false,
    });
  }

  get AvailableSkills(): SkillResponse[] {
    return vxm.skills.CompanySkillWrapper.skillResponses;
  }

  get countryList() {
    return vxm.passport.CountryList;
  }

  editSavedLicence() {
    this.editLicence = true;
    this.expandAll = false;
    this.skipLicenceAttributes = [];
    this.filteredCompanyVerticalLicence =
      vxm.licence.LicenseMasterDataWrapper.licenceMasterData;
    this.clearDisplayVerticalArr();
  }

  async saveEditedSkills() {
    this.editLicence = false;
    await vxm.licence.getUserLicenceData();
  }

  confirmDeleteLicence(licence, index) {
    console.log('delete called from here');
    this.$modal.show(
      ConfirmationModal,
      {
        header: this.$t('License_DeleteLicence'),
        body: '',
        okText: this.$t('global.ok.text'),
        cancelText: this.$t('global.cancel-text'),
        onOk: async () => {
          let respPromise: any;
          respPromise = vxm.licence.removeLicence(licence.licenceId);
          const resp = await respPromise;
          const self = this;
          if (resp.meta.success) {
            if (this.userLicenceList.length > 1) {
              this.userLicenceList.splice(index, 1);
            }
            this.selectedComponentKey++;

            this.$wlToastr(
              'success',
              this.$t('License_LicenceDeletedSuccessfully'),
              this.$t('License_LicenceText'),
            );
          }
        },
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }

  collapseAllMenu() {
    this.expandAll = false;
    this.clearDisplayVerticalArr();
  }

  openAllMenu() {
    this.expandAll = true;
    this.addAllVerticals();
  }

  toggleExpandCurrent() {
    this.expandCurrent = !this.expandCurrent;
  }
  getSearchedLicence(searchVal: string) {
    this.skipLicenceAttributes = [];
    if (searchVal == '') this.collapseAllMenu();
    else this.openAllMenu();

    this.filteredCompanyVerticalLicence = [];
    vxm.licence.LicenseMasterDataWrapper.licenceMasterData.forEach((value) => {
      const filteredSkills = value.licenceResponse.filter((doc) => {
        return doc.licenceName
          .toLowerCase()
          .startsWith(searchVal.toLowerCase());
      });
      var testObj = new LicenceMasterData();
      testObj.licenceResponse = filteredSkills;
      testObj.verticalName = value.verticalName;
      this.filteredCompanyVerticalLicence.push(testObj);
    });
  }

  get SearchedSkills(): SkillResponse[] {
    return this.filteredCompanySkills;
  }

  get VerticalSearchedLicences(): LicenceMasterData[] {
    return this.filteredCompanyVerticalLicence;
  }

  get UserLicences(): UserLicence[] {
    return this.userLicenceList;
  }

  hideModelDialog() {
    this.$modal.hide('verifieddocumentmodal');
  }

  async updateMasterLicenceListComponent(licence, index) {
    console.log('event recieved', licence, index);
    if (this.userLicenceList.length > 1) {
      this.userLicenceList.splice(index, 1);
    }
    await vxm.licence.getUserLicenceData();
    var arrayLength = this.userLicence.length;
    if (this.userLicence) {
      for (var i = 0; i < arrayLength; i++) {
        if (this.userLicence[i].licenceMasterId === licence.licenceMasterId) {
        }
      }
    }
  }
}
